/**
 * @generated SignedSource<<d43e59ba66c3ba81c226945f7a15a144>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedYMAL_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_viewer">;
  readonly " $fragmentType": "SharedYMAL_viewer";
};
export type SharedYMAL_viewer$key = {
  readonly " $data"?: SharedYMAL_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedYMAL_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedYMAL_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedItemsSection_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f464d7d810e5efe6d1b2b760151a4591";

export default node;
